import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportManagementEndpoint } from '../constants/transport-management-endpoint';
import { TransportManagementSearchCriteria } from '../models/transport-management.model';
import { Observable } from 'rxjs';
import { TransportManagementTile } from '../models';

@Injectable({ providedIn: 'root' })
export class TransportManagementTransportOrderService {
  private readonly url = `${API_URL}${TransportManagementEndpoint.Base}${TransportManagementEndpoint.TransportOrders}`;
  constructor(private http: WrapperHttpService) {}

  getTransportManagementTransportOrderList({
    size,
    page,
    ...filter
  }: TransportManagementSearchCriteria): Observable<TransportManagementTile> {
    return this.http.withLoading().post<TransportManagementTile>(this.url, { size, page, filter });
  }
}
